export const EMPTY_PLAN_OBJECT = {
  name: "",
  sunday: { isOpenDropdown: false, visits: [], score: 0 },
  monday: { isOpenDropdown: false, visits: [], score: 0 },
  tuesday: { isOpenDropdown: false, visits: [], score: 0 },
  wednesday: { isOpenDropdown: false, visits: [], score: 0 },
  thursday: { isOpenDropdown: false, visits: [], score: 0 },
  friday: { isOpenDropdown: false, visits: [], score: 0 },
  saturday: { isOpenDropdown: false, visits: [], score: 0 }
};

export const EMPTY_RES_SCHEDULE_JSON = {
  isOpenDropdown: false,
  score: 0,
  visits: []
};
